import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
type Props = {
  text: string;
  label: string;
  copiedLabel?: string;
  iconOnly?: boolean;
};
export function CopyTextButton({
  text,
  label,
  copiedLabel = 'Copiado',
  iconOnly = false
}: Props) {
  const [copied, setCopied] = useState(false);
  const copy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const input = document.createElement('textarea');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };
  const Icon = copied ? Check : Copy;
  const current = copied ? copiedLabel : label;
  if (iconOnly) {
    return <button type="button" onClick={copy} aria-label={`${current}: ${text}`} title={current} className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ${copied ? 'text-[#D4AF37]' : 'text-gray-400 hover:bg-white/5 hover:text-white'}`} data-id="element-1133" data-mp="32pzq5sd703ev">
        <Icon className="h-4 w-4" aria-hidden="true" data-id="element-1134" data-mp="1hgqtz03lr3op" />
      </button>;
  }
  return <button type="button" onClick={copy} className="inline-flex h-11 items-center gap-2 rounded-full border border-[#D4AF37]/50 bg-[#D4AF37]/10 px-4 text-sm font-semibold text-[#F3E5AB] whitespace-nowrap transition-colors duration-150 hover:bg-[#D4AF37]/20" data-id="element-1135" data-mp="1che74fcqdwm4">
      <Icon className="h-4 w-4" aria-hidden="true" data-id="element-1136" data-mp="1lfyiswjvj60u" />
      <span aria-live="polite" data-id="element-1137" data-mp="205nqzbqdwaam">{current}</span>
    </button>;
}